export default {
  logged: false,
  username: null,
  token: null,
  dataErrored: false,
  articles: [],
  articlesErrored: false,
  contact: [],
  contributors: [],
  downloadable: null,
  homeVideo: null,
  faq: [],
  serverStatus: 'loading',
  versionFile: null
}



// WEBPACK FOOTER //
// ./src/store/State.js